module.exports = __webpack_public_path__ + "img/smartphone.74234a91.svg";